import { render } from "./ModalItemsNotAvailable.vue?vue&type=template&id=715a3e36"
import script from "./ModalItemsNotAvailable.vue?vue&type=script&lang=js"
export * from "./ModalItemsNotAvailable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__